import React from 'react';
import Header from '../components/Header';
import { Handshake, Star, BookOpen, ChevronRight, IconBadge } from '../components/icons';

const OP_CSS = `
.op-card { transition: transform .16s cubic-bezier(.22,.68,0,1), border-color .25s ease; -webkit-tap-highlight-color: transparent; }
.op-card:active { transform: scale(.985); }
@media (prefers-reduced-motion: reduce) { .op-card, .op-anim { animation: none !important; transition: none; } }
`;

export default function OtherPage({ onNavigate, role }) {
  const rest = [
    { icon: <Handshake />, title: 'Партнёрская программа', subtitle: 'Ваша ссылка и приглашённые', tab: 'partner' },
    (role === 'expert' || role === 'admin')
      ? { icon: <Star />, title: 'Мои темы эксперта', subtitle: 'По каким темам вы помогаете в клубе', tab: 'expert-topics' }
      : null,
  ].filter(Boolean);

  return (
    <div>
      <style>{OP_CSS}</style>
      <Header title="Другое" />
      <div style={{ padding: '16px 16px 100px', display: 'flex', flexDirection: 'column', gap: 12 }}>

        {/* Библиотека — выделенная крупная карточка сверху */}
        <div onClick={() => onNavigate('library')} className="op-card op-anim"
          style={{
            background: 'linear-gradient(135deg, rgba(255,204,0,0.10), var(--bg-card) 70%)',
            borderRadius: 20, padding: '22px 20px',
            border: '1px solid rgba(255,204,0,0.35)', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 18,
            animation: 'fadeInUp 0.4s ease 0.04s both',
          }}>
          <IconBadge accent size={64} iconSize={32}>{<BookOpen />}</IconBadge>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 19, fontWeight: 700, letterSpacing: -0.2 }}>Библиотека</div>
            <div style={{ fontSize: 13.5, color: 'var(--text-secondary)', marginTop: 4, lineHeight: 1.35 }}>Материалы, документы, видео и ответы</div>
          </div>
          <span style={{ color: 'var(--accent)', display: 'flex', flexShrink: 0 }}><ChevronRight size={22} /></span>
        </div>

        {/* Остальные разделы — обычные строки */}
        {rest.map((it, i) => (
          <div key={it.tab} onClick={() => onNavigate(it.tab)} className="op-card op-anim"
            style={{
              background: 'var(--bg-card)', borderRadius: 16, padding: '14px 16px',
              border: '1px solid var(--border)', cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 14,
              animation: `fadeInUp 0.4s ease ${0.1 + i * 0.05}s both`,
            }}>
            <IconBadge accent size={44} iconSize={22}>{it.icon}</IconBadge>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 600 }}>{it.title}</div>
              <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginTop: 2 }}>{it.subtitle}</div>
            </div>
            <span style={{ color: 'var(--text-tertiary)', display: 'flex', flexShrink: 0 }}><ChevronRight size={18} /></span>
          </div>
        ))}
      </div>
    </div>
  );
}
